import React from 'react';

const Release = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Release
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Buyer releases, quit claims and forever discharges seller, all
          brokers, their licensees, employees and any officer or partner of any
          one of them and any other person, firm or corporation who may be
          liable by or through them, from any and all claims, losses or demands,
          including, but not limited to, personal injury and property damage and
          all of the consequences thereof, whether known or not, which may arise
          from the presence of termites or other wood-boring insects, radon,
          lead-based paint hazards, mold, fungi or indoor air quality,
          environmental hazards, any defects in the individual on-lot sewage
          disposal system or deficiencies in the on-site water service system,
          or any defects or conditions on the Property. Should Seller be in
          default under the terms of this Agreement or in violation of any
          Seller disclosure law or regulation, this release does not deprive
          Buyer of any right to pursue any remedies that may be available under
          law or equity. This release will survive settlement.
        </li>
      </ol>
    </div>
  );
};

export default Release;
